import { render, staticRenderFns } from "./innovateInfo.vue?vue&type=template&id=6caf430b&scoped=true&"
import script from "./innovateInfo.vue?vue&type=script&lang=js&"
export * from "./innovateInfo.vue?vue&type=script&lang=js&"
import style0 from "./innovateInfo.vue?vue&type=style&index=0&id=6caf430b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6caf430b",
  null
  
)

export default component.exports